import { render, staticRenderFns } from "./DraftListEditB4.vue?vue&type=template&id=8f5ee3fa"
import script from "./DraftListEditB4.vue?vue&type=script&lang=js"
export * from "./DraftListEditB4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports